import React from 'react';
import { Col } from 'reactstrap';
import { node } from 'prop-types';

const propTypes = { children: node };

const LayoutCol = ({ children, ...rest }) => (
  <Col lg="12" {...rest}>
    {children}
  </Col>
);

LayoutCol.propTypes = propTypes;
export default LayoutCol;
